package one.healthium.profile.ui.food.models

import one.healthium.base.utils.toString

data class AmountUiModel(
    val integerPart: Int,
    val floatingPart: FloatPart,
    val unit: Units,
    val units: List<Units>,
) {
    val value = integerPart + floatingPart.value

    val displayValue: String = unit.format(value)
    val grams: Float = value * unit.gramValue

    val hundredGrams: Float
        get() = grams / 100

    companion object {
        fun availableUnits(
            isMetric: Boolean,
            tablespoon: Float?,
            cups: Float?,
            pieces: Float?,
            portion: Float?,
            isLiquid: Boolean
        ) = buildList {
            if (isMetric) {
                add(Units.Gram)
                if (isLiquid) add(Units.Ml)
            } else {
                add(Units.Oz)
                if (isLiquid) add(Units.FlOz)
            }
            if (tablespoon != null && tablespoon > 0) {
                add(Units.Tablespoon(tablespoon))
                add(Units.Teaspoon(tablespoon / 3))
            }
            if (cups != null && cups > 0) {
                add(Units.Cup(cups))
            }
            if (pieces != null && pieces > 0) {
                add(Units.Piece(pieces))
            }
            if (portion != null && portion > 0) {
                add(Units.Portion(portion))
            }
        }

        fun defaultUnit(isMetric: Boolean, isLiquid: Boolean): Units {
            return if (isMetric) {
                if (isLiquid) Units.Ml else Units.Gram
            } else {
                if (isLiquid) Units.FlOz else Units.Oz
            }
        }

        val preview = AmountUiModel(
            integerPart = 5000,
            floatingPart = FloatPart.Zero,
            unit = Units.Gram,
            units = listOf(Units.Gram, Units.Ml, Units.Oz)
        )
    }
}

enum class FloatPart(
    val displayValue: String,
    val value: Float,
) {
    Zero("0", 0f),
    OneEighth("⅛", 1 / 8f),
    OneQuarter("¼", 1 / 4f),
    OneThird("⅓", 1 / 3f),
    OneHalf("½", 1 / 2f),
    TwoThirds("⅔", 2 / 3f),
    ThreeQuarters("¾", 3 / 4f),
    SevenEighths("⅞", 7 / 8f);

    companion object {
        fun valueOf(value: Float): FloatPart {
            val floatingPart = value - value.toInt()
            entries.forEach { entry ->
                if (floatingPart.toString(1) == entry.value.toString(1)) {
                    return entry
                }
            }
            return Zero
        }
    }
}